import { useMemo } from 'react';
import { schema } from '@/auth/presentation/validators/NewPasswordSchema';
import { UseForm, UseFormReturn } from '@/shared/application/hooks';
import { useLocation } from 'react-router-dom';
import { useNewPassword } from './useNewPassword';

type UseNewPasswordReturn<T> = {
  loading: boolean;
  form: UseFormReturn<T>;
};

type UseNewPasswordProps<T> = {
  useForm: UseForm<T>;
};

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export const useNewPasswordForm = ({
  useForm,
}: UseNewPasswordProps<any>): UseNewPasswordReturn<any> => {
  const query = useQuery();
  const { newPassword, loading } = useNewPassword();

  const form = useForm({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    onSubmit: (values) => {
      newPassword({ ...values, token: query.get('token') });
    },
    validationSchema: schema,
  });

  return {
    form,
    loading,
  };
};
